import React, { useState } from "react";
import { Modal, Button, Row, Col, Container } from "react-bootstrap";
import style from "../Modal.module.scss";
import { TODIS_FORM_FIELD_DATE_FORM,TODIS_FORM_FIELD_DATE_YEAR } from "../../Forms";
import { Formik, Form } from "formik";
import { TODIS_KPI_PERIOD_INIT, TODIS_KPI_PERIOD_VALID } from "../../../.config/KPI/modal_KPI";
import { BsArrowRight, BsExclamationCircleFill } from "react-icons/bs";
import { TODIS_DATEPICKER } from "../../Buttons";

const TODIS_MODAL_KPI_PERIOD = ({onCalculate, ...props}) => {
    
    const handleDate = (data, field, setFieldValue) => {
        setFieldValue(field, data)
    }

    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={`${style.smwidth} ${style.todisModalContainer}`}
            className={`${style.todisModalContainer} ${style.smwidth}`}
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Formik
                            initialValues={TODIS_KPI_PERIOD_INIT}
                            validationSchema={TODIS_KPI_PERIOD_VALID}
                            onSubmit={(values) => onCalculate(values)}>
                            {({ errors, touched, setFieldValue }) => (
                                <Form className="todis-form-content">
                                    <Row>
                                        <Col lg={12}>
                                            <TODIS_FORM_FIELD_DATE_YEAR id="rangeFrom" label="Select year" name="rangeFrom"  setFieldValue={setFieldValue}/>
                                            {errors.rangeFrom && touched.rangeFrom ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.rangeFrom}</div>) : null}
                                        </Col>
                                        {/* <Col lg={6}>
                                            <TODIS_DATEPICKER id="rangeTo" name="rangeTo" handleDate={(data) => handleDate(data, "rangeTo", setFieldValue)} placeholder="Base Period" onlyYearPicker={false} text="Accept" containerStyle={{display: "block"}}/>
                                            {errors.rangeTo && touched.rangeTo ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.rangeTo}</div>) : null}
                                        </Col> */}
                                    </Row>
                                    <div className="todis-action-form">
                                        <Button variant="outline-danger" onClick={() => props.onHide()} className={style.todisBtnOutline}>DISCARD </Button>
                                        <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{margin: "0.5rem"}} type="submit">CALCULATE</Button>
                                    </div>
                                </Form>
                            )}
                    </Formik> 
                </Container>  
            </Modal.Body>
        </Modal>
    )
}

export { TODIS_MODAL_KPI_PERIOD };